import { Loading } from '@tellus/component'
import { CONTENT_TYPE, HTTP_METHOD } from '@tellus/http'
import { HTTP_ERROR_TYPE } from '@tellus/http-hooks/src/const'
import { jsonData, multipartData } from '@tellus/http-hooks/src/helper/process-data'
import { processResponse } from '@tellus/http-hooks/src/helper/process-res'
import { isFunction } from '@tellus/utils'

/**
 * @description: Process the request before sending it
 * @param {*} config
 * @param {*} params
 * @param {*} requestOptions
 */
let loadingCount = 0
//let loading = {}
export function beforeRequestHook(config, params, requestOptions) {
  loadingCount = loadingCount + 1

  //Loading.show(document.querySelector('#template'), 'create-isLoading', '', '')
  //Loading.show(document.body, 'create-isLoading', '', '')
  // loading = this.$loading({
  //   target: document.querySelector('#firstDiv'),
  //   customClass: 'create-isLoading', //显示在加载图标下方的加载文案
  //   spinner: ''
  // })
  // merge http params or data to config
  if (params) {
    config.params = null
    config.data = null


    const contentType = config.headers?.contentType || CONTENT_TYPE.JSON

    // type 'multipart/form-data;'
    if (contentType === CONTENT_TYPE.FORM_DATA) {

      if (config.method.toUpperCase() === HTTP_METHOD.POST) {
        config.data = multipartData(params)
      } else {
        throw new Error(HTTP_ERROR_TYPE.UNSUPPORT_MULTIPART_METHOD)
      }
    } else {
      config = jsonData(params, config, requestOptions)
    }
  }
  return config
}

/**
 * @description: Process success request
 */
export function afterRequestHook(res, requestOptions, resolve, reject) {
  loadingCount = loadingCount - 1
  setTimeout(() => {
    if (loadingCount == 0) {
      Loading.close()
      // loading.close()
    }
  }, 500)

  const { isReturnNativeResponse, isSkipRequestHook, messageMode, processLogic } = requestOptions

  // Whether to return native response, No processing, return directly
  // For example: use this attribute when you need to get the response headers
  if (isReturnNativeResponse) {
    return resolve(res)
  }

  // No processing, return directly
  // It is used when the page code may need to directly obtain the information such as Status, Data, and Messages.
  if (isSkipRequestHook) {
    return resolve(res.data)
  }

  // Parse response with processLogic
  if (processLogic && isFunction(processLogic)) {
    return processLogic(res, requestOptions, resolve, reject)
  }

  return processResponse(res, resolve, reject, { messageMode })
}
